(()=>{
  if(window.__vivaSourceAlignInstalled)return;
  window.__vivaSourceAlignInstalled=true;
  const previousFetch=window.fetch.bind(window);
  const ASK_RE=/\/api\/ask-viva(?:$|[?#])/;
  const ALLOWED=new Set(['image/jpeg','image/jpg','image/png','image/webp']);
  const fail=reason=>{const e=new Error('MOBILE_UPLOAD_INVALID');e.vivaReason=reason;throw e;};
  const targetSize=(w,h)=>{
    w=Number(w);h=Number(h);
    if(!Number.isFinite(w)||!Number.isFinite(h)||w<32||h<32)return null;
    const ratio=w/h;
    if(ratio>3||ratio<1/3)return null;
    const maxArea=1500000,minArea=655360,area=Math.min(maxArea,Math.max(minArea,w*h));
    const scale=Math.sqrt(area/(w*h));
    let ow=Math.max(16,Math.round((w*scale)/16)*16);
    let oh=Math.max(16,Math.round((ow/ratio)/16)*16);
    if(ow*oh>maxArea*1.04){oh=Math.max(16,Math.floor((maxArea/ow)/16)*16);}
    if(ow*oh<minArea){const s=Math.sqrt(minArea/(ow*oh));ow=Math.ceil(ow*s/16)*16;oh=Math.max(16,Math.round((ow/ratio)/16)*16);}
    if(ow*oh>8294400||Math.max(ow,oh)>3840)return null;
    return {width:ow,height:oh};
  };
  const decodeHtml=async file=>{
    const url=URL.createObjectURL(file),img=new Image();
    try{
      img.decoding='async';img.src=url;
      if(typeof img.decode==='function')await img.decode();
      else await new Promise((ok,no)=>{img.onload=ok;img.onerror=no;});
      const w=img.naturalWidth,h=img.naturalHeight;
      if(!w||!h)throw new Error('NO_DIMENSIONS');
      return {source:img,width:w,height:h,cleanup:()=>URL.revokeObjectURL(url)};
    }catch(error){URL.revokeObjectURL(url);throw error;}
  };
  const decodeBitmap=async file=>{
    if(typeof createImageBitmap!=='function')throw new Error('BITMAP_UNAVAILABLE');
    let bitmap;
    try{bitmap=await createImageBitmap(file,{imageOrientation:'from-image'});}catch(_){bitmap=await createImageBitmap(file);}
    if(!bitmap?.width||!bitmap?.height){bitmap?.close?.();throw new Error('NO_DIMENSIONS');}
    return {source:bitmap,width:bitmap.width,height:bitmap.height,cleanup:()=>bitmap.close?.()};
  };
  const normalize=async file=>{
    if(!(file instanceof File)||!file.size)fail('EMPTY_FILE');
    const type=String(file.type||'').toLowerCase();
    if(!ALLOWED.has(type))fail('UNSUPPORTED_FORMAT');
    let decoded;
    try{decoded=await decodeHtml(file);}catch(_){try{decoded=await decodeBitmap(file);}catch(__){fail('DECODE_FAILED');}}
    const {width:w,height:h}=decoded,size=targetSize(w,h);
    if(!size){decoded.cleanup();fail('INVALID_DIMENSIONS');}
    const canvas=document.createElement('canvas');canvas.width=size.width;canvas.height=size.height;
    const ctx=canvas.getContext('2d',{alpha:false});
    if(!ctx){decoded.cleanup();fail('CANVAS_UNAVAILABLE');}
    ctx.fillStyle='#ffffff';ctx.fillRect(0,0,canvas.width,canvas.height);
    ctx.imageSmoothingEnabled=true;ctx.imageSmoothingQuality='high';
    try{ctx.drawImage(decoded.source,0,0,size.width,size.height);}catch(_){decoded.cleanup();fail('DRAW_FAILED');}
    decoded.cleanup();
    const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/jpeg',.94));
    if(!blob||blob.size<1024)fail('ENCODE_FAILED');
    const normalized=new File([blob],'room-normalized.jpg',{type:'image/jpeg',lastModified:file.lastModified||Date.now()});
    return {file:normalized,sourceWidth:w,sourceHeight:h,width:size.width,height:size.height,ratio:w/h,orientation:w>=h?'landscape':'portrait'};
  };
  window.fetch=async(input,init={})=>{
    const url=typeof input==='string'?input:String(input?.url||'');
    const form=init?.body;
    if(ASK_RE.test(url)&&form instanceof FormData){
      const photo=form.get('photo');
      if(photo instanceof File){
        const n=await normalize(photo);
        form.set('photo',n.file,n.file.name);
        form.set('source_lock','client_canvas_v2');
        form.set('source_normalized','client_canvas_v2');
        form.set('source_width',String(n.sourceWidth));
        form.set('source_height',String(n.sourceHeight));
        form.set('normalized_width',String(n.width));
        form.set('normalized_height',String(n.height));
        form.set('source_aspect_ratio',String(n.ratio));
        form.set('source_orientation',n.orientation);
      }
    }
    return previousFetch(input,init);
  };
})();
